import "babel-polyfill"; // 解决Ie9
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import {Element, Message } from 'element-ui';
import "./element";
import * as filters from "./filtres/index"; // 全局过滤器
import "./role"; // 权限

import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(VueQuillEditor)
// Vue.use(ElementUI);

// import "./mock"; // 模拟数据

import "./assets/icons/iconfont";
import IconSvg from "./components/common/IconSvg.vue"; // svg组件

// 注册全局组件（register global）
Vue.component("icon-svg", IconSvg);

import "./assets/common.css";

Vue.prototype.$errMsg = function( msg){
    Message( {message: msg, type: "error", customClass: "cmd_msg_zindex"});
}
Vue.prototype.$succMsg = function( msg){
    Message( {message: msg, type: "success", customClass: "cmd_msg_zindex"});
}

// 注册全局实用程序过滤器（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
